import { useState } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    id: 1,
    bg: "bg-[#1a1a1a]",
    overlayStyle: "from-black/60 via-black/30 to-transparent",
    eyebrow: "Imperdível",
    title: "Como Vender Mais Usando o Método CAT (Cliente com Atenção o Tempo Todo) e Ferramentas de IA",
    subtitle: "Transforme seu resultado: vendas, varejo, WhatsApp Business e IA aplicados para fazer você faturar mais já nos primeiros dias.",
    cta: "Compre agora",
    ctaSecondary: "Explorar",
    align: "left",
    image: "",
    imageMode: "bg",
    contentOffset: "mt-[1cm]",
  },
  {
    id: 2,
    bg: "bg-[#1a1208]",
    overlayStyle: "from-black/60 via-black/30 to-transparent",
    eyebrow: "Especialista",
    title: "Gleice Lyra",
    subtitle: "Referência em vendas, varejo, multimarcas e comportamento do consumidor. Conheça uma metodologia que está mudando as equipes em todo o Brasil.",
    cta: "Conheça a Gleice",
    ctaSecondary: "Método CAT",
    align: "left",
    image: "https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/47b68a2a-669a-4028-a55a-db99149e15a8_Gleice.png?v=b1ce88b4ce58c92c6097cac96816f8c8",
    imageMode: "portrait",
    contentOffset: "",
  },
  {
    id: 3,
    bg: "bg-[#111827]",
    overlayStyle: "from-black/60 via-black/50 to-black/60",
    eyebrow: "Just Landed",
    title: "Novidades desta semana",
    subtitle: "Mais uma semana. Seja o primeiro a categoria e ganhe 2 bônus exclusivos",
    cta: "Compre agora",
    ctaSecondary: "Ver curso completo",
    align: "center",
    image: "https://readdy.ai/api/search-image?query=aesthetic%20minimalist%20desk%20flatlay%20with%20an%20open%20planner%20calendar%20notebook%2C%20dried%20flowers%2C%20golden%20pen%2C%20soft%20warm%20candlelight%2C%20pastel%20cream%20and%20beige%20tones%2C%20cozy%20elegant%20workspace%2C%20shallow%20depth%20of%20field%2C%20styled%20lifestyle%20photography%2C%20very%20detailed%2C%20cinematic%20warm%20lighting%2C%20luxury%20stationery%20arrangement%20on%20marble%20surface&width=1440&height=900&seq=calendaraesthetic3&orientation=landscape",
    imageMode: "bg",
    contentOffset: "",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const goTo = (idx: number) => setCurrent(idx);
  const prev = () => setCurrent((c) => (c - 1 + slides.length) % slides.length);
  const next = () => setCurrent((c) => (c + 1) % slides.length);

  const slide = slides[current];

  const handleCta = (cta: string) => {
    if (cta === "Compre agora") {
      navigate("/nossos-produtos");
    }
  };

  return (
    <div className={`relative w-full h-screen min-h-[680px] ${slide.bg} overflow-hidden transition-all duration-700`}>

      {/* Background image — only for bg mode */}
      {slide.image && slide.imageMode === "bg" && (
        <div
          className="absolute inset-0 bg-cover bg-top"
          style={{ backgroundImage: `url(${slide.image})` }}
        />
      )}

      {/* Decorative grid pattern */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg,transparent,transparent 79px,rgba(255,255,255,0.08) 80px), repeating-linear-gradient(90deg,transparent,transparent 79px,rgba(255,255,255,0.08) 80px)",
        }}
      />

      {/* Gradient overlay */}
      <div className={`absolute inset-0 bg-gradient-to-r ${slide.overlayStyle}`} />

      {/* Portrait image — Gleice Lyra style */}
      {slide.image && slide.imageMode === "portrait" && (
        <div className="absolute bottom-0 right-0 w-[42%] h-full pointer-events-none flex items-end justify-center">
          <div
            className="absolute inset-0 z-10"
            style={{
              background:
                "linear-gradient(to right, #1a1208 0%, transparent 40%), linear-gradient(to top, #1a1208 0%, transparent 15%)",
            }}
          />
          <img
            src={slide.image}
            alt="Gleice Lyra"
            className="relative z-0 h-full w-full object-contain object-bottom"
          />
        </div>
      )}

      {/* Decorative vertical logo watermark */}
      <div className="absolute right-12 top-1/2 -translate-y-1/2 hidden lg:flex flex-col items-center gap-3">
        <div className="w-16 h-16 flex items-center justify-center opacity-20">
          <img
            src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/a6c5ba46-23d3-4524-be18-4256952d13d1_LOGO-CLIENTIZAH.png?v=93ab9526541dbc623a0c897116118335"
            alt="Clientizah"
            className="w-full h-full object-contain filter invert"
          />
        </div>
      </div>

      {/* Main content */}
      <div
        className={`relative z-10 h-full flex flex-col justify-center px-16 md:px-24 ${
          slide.align === "center"
            ? "items-center text-center"
            : slide.align === "right"
            ? "items-end text-right"
            : "items-start text-left"
        }`}
      >
        <div className={`max-w-2xl ${slide.contentOffset ?? ""}`}>
          <h1 className="text-white text-xl md:text-3xl font-light leading-none mb-6 tracking-tight">
            {slide.title}
          </h1>
          <p className="text-white/80 text-base md:text-lg font-light leading-relaxed mb-10 max-w-lg">
            {slide.subtitle}
          </p>
          <div className={`flex gap-4 ${slide.align === "center" ? "justify-center" : slide.align === "right" ? "justify-end" : "justify-start"}`}>
            <button
              onClick={() => handleCta(slide.cta)}
              className="whitespace-nowrap bg-white text-black text-xs tracking-widest uppercase px-8 py-4 hover:bg-gray-100 transition cursor-pointer font-medium"
            >
              {slide.cta}
            </button>
            <button className="whitespace-nowrap border border-white text-white text-xs tracking-widest uppercase px-8 py-4 hover:bg-white hover:text-black transition cursor-pointer font-medium">
              {slide.ctaSecondary}
            </button>
          </div>
        </div>
      </div>

      {/* Decorative store image — slide 1 only */}
      {slide.id === 1 && (
        <div className="absolute bottom-0 right-0 w-[45%] h-[75%] pointer-events-none">
          <div
            className="absolute inset-0 z-10"
            style={{
              background:
                "linear-gradient(to right, #1a1a1a 0%, transparent 35%), linear-gradient(to top, #1a1a1a 0%, transparent 30%), linear-gradient(to bottom-right, transparent 60%, #1a1a1a 100%)",
            }}
          />
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20modern%20boutique%20interior%20with%20warm%20golden%20lighting%2C%20minimalist%20white%20shelves%20displaying%20neatly%20folded%20clothes%2C%20aesthetic%20fashion%20retail%20store%20with%20marble%20floors%20and%20soft%20ambient%20light%2C%20high-end%20luxury%20atmosphere%2C%20clean%20and%20bright%20interior%20design%2C%20stylish%20clothes%20racks%20with%20curated%20outfits&width=900&height=700&seq=herostore1&orientation=landscape"
            alt="Loja estética"
            className="w-full h-full object-cover object-center opacity-60"
          />
        </div>
      )}

      {/* Slide navigation arrows */}
      <button
        onClick={prev}
        className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 border border-white/40 flex items-center justify-center text-white hover:bg-white hover:text-black transition cursor-pointer"
      >
        <i className="ri-arrow-left-line text-sm"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 border border-white/40 flex items-center justify-center text-white hover:bg-white hover:text-black transition cursor-pointer"
      >
        <i className="ri-arrow-right-line text-sm"></i>
      </button>

      {/* Slide dots */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`cursor-pointer transition-all duration-300 ${
              i === current ? "w-8 h-[2px] bg-white" : "w-3 h-[2px] bg-white/40"
            }`}
          />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 right-16 hidden md:flex flex-col items-center gap-2">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-[1px] h-10 bg-white/30 relative overflow-hidden">
          <div className="absolute top-0 w-full h-1/2 bg-white/70 animate-bounce" />
        </div>
      </div>
    </div>
  );
}